export default "__VITE_ASSET__B87eyL1W__"